import React from "react"

export default function Blog034() {
  return (
    <section>
    <article>
    <h2>34. 01-02-2023</h2>
          <h3>The New Year</h3>
          <p>
          <strong>Hello!</strong>
          <br /><br />
          As a self-taught software engineer, I've always been interested in picking up new skills and advancing my knowledge of various technologies. I've been concentrating on NoSql database tools like Firebase and MongoDB during the past few months. With the help of these technologies, I was able to deal with a lot of data and create robust applications that can withstand high traffic and user engagement.
          <br /><br />
          I have recently thought of taking a different route and learning Python and SQL. A standard SQL database may be the best option in many instances, despite the benefits of NoSql databases. I can better understand how databases function and be more flexible in my projects if I study SQL.
          <br /><br />
          In addition to learning SQL, I'm also curious to learn about Python. From web development to data analysis, this potent programming language is frequently utilized in a wide range of applications. I can increase my possibilities for developing and deploying applications by learning Python, and I'll also be able to add another useful skill to my toolkit.
          <br /><br />
          I'm really thrilled about one project, which is using a Raspberry Pi 3 to create my own server. Although I had previously used cloud-based servers, there is a certain satisfaction in creating and maintaining your own server. I can make a versatile, inexpensive, and energy-efficient server with a Raspberry Pi. A Raspberry Pi server may be a useful addition to any developer's toolkit, whether it's used to host a website or manage a database.
          <br /><br />
          I am eager to start these learning experiences and take on brand-new tasks as the new year approaches. I'm constantly searching for new opportunities to challenge myself as a developer, whether it is by picking up a new language or creating my own server. I'm confident that with perseverance and hard work, I can accomplish my objectives and keep improving my abilities. So, these are the tasks that I want to finish this year. I hope it works!



<br /><br />
Thanks for reading,<br />
Eric Polley
<br />



         
          </p>
          
          </article>

        <h4>Links</h4>
        <br />
        <ul>
        <li>
            <a
              href="http://resume.ericpolley.com/"
              title="Check out my Resume!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley - Resume</p></strong></
            a>
          </li>
        
          <li>
            <a
              href="http://ericpolley.com"
              title="Check out my Portfolio!"
              target="_blank"
              rel="noopener noreferrer" 
            >
              <strong><p>Eric Polley's Website</p></strong></a
            >
          </li>
        </ul>
        </ section >
  )
}
